import * as React from "react"
import { App } from "./app"
import { BDKalkCore } from "./BDKalkCore"
import { SelectionSetGW } from "./SelectionSetGW"
import { BuildPartGW } from "./BuildPartGW"

///////////////   ProjectItem  ////////////////

export interface ProjectItemVm {
    core: BDKalkCore,
    index: number,
    proRef: SelectionSetGW,
    proSummary: BuildPartGW | null
}

export interface ProjectItemStates {
    mouseState: string,
    mergeButtonState: number, // 0: out, 1: out_Hover, 2:over, 3:pressed
    loadButtonState: number, // 0: out, 1: out_Hover, 2:over, 3:pressed
    delButtonState: number // 0: out, 1: out_Hover, 2:over, 3:pressed
}

/*  ProjectItem is a graphical component for displaying and using previously stored article selections.
    It displays the name of the saved project and hold two buttons, one which will load the stored
    selections, replacing the current quick report, but also a merge button that will combine the
    current selections with the stored selections. */

export class ProjectItem extends React.Component<ProjectItemVm, ProjectItemStates> {
    // Initial state
    state: ProjectItemStates = {
        mouseState: (this.props.core.GetSelectionSetManager().GetHoveredProjectIndex() == this.props.index)?"hover":"out",
        mergeButtonState: 0, // 0: out, 1: out_Hover, 2:over, 3:pressed
        loadButtonState: 0, // 0: out, 1: out_Hover, 2:over, 3:pressed
        delButtonState: 0 // 0: out, 1: out_Hover, 2:over, 3:pressed
    }
    
    // Mouse up handler
    onMouseUp() {
        var mergestate = this.state.mergeButtonState
        var loadState = this.state.loadButtonState

        // If the mouse has entered the merge button, the merge button will now become pressed
        if (this.state.mergeButtonState == 2) {
            mergestate = 3
        }

        // If the mouse has entered the load button, the load button will now become pressed
        if (this.state.loadButtonState == 2) {
            loadState = 3
        }

        this.setState({ mouseState: "hover", mergeButtonState: mergestate, loadButtonState: loadState })
    }
    
    // Mouse out handler
    onMouseOut(e: React.MouseEvent<HTMLDivElement>) {
        setTimeout(this.props.core.GetProjectView().forceUpdate.bind(this.props.core.GetProjectView()), 20)
        this.setState({ mouseState: "out", mergeButtonState: 0, loadButtonState:0 })
    }

    // Mouse over handler
    onMouseOver(e: React.MouseEvent<HTMLDivElement>) {
        this.props.core.GetSelectionSetManager().SetHoveredProjectIndex(this.props.index)
        var mergeNewState = 1
        var loadNewState = 1

        if (this.state.mergeButtonState == 2) {
            mergeNewState = 2
        }

        if (this.state.loadButtonState == 2) {
            loadNewState = 2
        }

        this.setState({ mouseState: "hover", mergeButtonState: mergeNewState, loadButtonState: loadNewState })
        this.forceUpdate()
    }

    // Mouse over handler
    onMouseOverWhole(e: React.MouseEvent<HTMLDivElement>) {
        this.props.core.GetSelectionSetManager().SetHoveredProjectIndex(-1)
    }

    // Mouse down (pressed) handler
    onMouseDown(e: React.MouseEvent<HTMLDivElement>) {
        var mergestate = this.state.mergeButtonState
        var loadState = this.state.loadButtonState

        // If the mouse has entered the merge button, the merge button will now become pressed
        if (this.state.mergeButtonState == 2) {
            mergestate = 3
        }

        // If the mouse has entered the load button, the load button will now become pressed
        if (this.state.loadButtonState == 2) {
            loadState = 3
        }

        this.setState({ mouseState: "hover", mergeButtonState: mergestate, loadButtonState: loadState })
    }
    
    // Returns true if this project item is the currently hovered one
    isSelected() {
        if (this.props.core.GetSelectionID() == this.props.proRef.GetId()) {
            return true
        } 
        else {
            return false
        }
    }

    // Returns true if this project item is the currently hovered one
    isHovered() {
        if (this.props.core.GetProjectView().GetHoveredItem() == this.props.index) {
            return true
        }
        else {
            return false
        }
    }
    
    /**
        OnSaveFirst() {
            this.props.app.GetCore().GetSelectionSetManager().SaveProject(this.props.app.GetCore().GetSelectionSetManager().GetCurrentProjectName())
            this.props.app.GetCore().ClearAllQRArticles()
            this.props.app.GetCore().ClearAllQRBuildParts()
            this.props.app.GetCore().GetSelectionSetManager().SetCurrentProjectNameToNew()
            this.setState({ stage: "saved" })
        }

        OnJustLoad() {
            this.props.app.GetCore().ClearAllQRArticles()
            this.props.app.GetCore().ClearAllQRBuildParts()
            this.props.app.GetCore().GetSelectionSetManager().SetCurrentProjectNameToNew()
            this.setState({ stage: "performed" })
        }
    */
    
    // Load button handlers
    OnMouseClickLoadButton(e: React.MouseEvent<HTMLDivElement>) {
        const proView = this.props.core.GetProjectView()

        if (proView) {
            const core = this.props.core
            const manager = core.GetSelectionSetManager()

            if ((core.GetSelectedBuildParts().length > 0) || (core.GetSelectedArticles().length > 0)) {
                proView.SetItemToLoad(this.props.proRef)
                proView.setState({ stage: "savePreviousQuestion" })
            }
            else {
                manager.loadProject(this.props.proRef)
                proView.setState({ stage: "loadingProject" })
            }
        }
    }
    
    OnMouseOutLoadButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ loadButtonState: 1 })
        this.forceUpdate()
    }

    OnMouseOverLoadButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ loadButtonState: 2 })
        this.forceUpdate()
    }

    OnMouseDownLoadButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ loadButtonState: 3 })
        this.forceUpdate()
    }

    OnMouseUpLoadButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ loadButtonState: 2 })
        this.forceUpdate()
    }

    // Merge button Handlers
    OnMouseClickMergeButton(e: React.MouseEvent<HTMLDivElement>) {
        this.props.core.GetSelectionSetManager().mergeProject(this.props.proRef)
        const proView = this.props.core.GetProjectView()
        if (proView) {
            proView.setState({ stage: "mergingProject" })
        }
    }

    OnMouseOutMergeButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ mergeButtonState: 1 })
        this.forceUpdate()
    }

    OnMouseOverMergeButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ mergeButtonState: 2 })
        this.forceUpdate()
    }

    OnMouseDownMergeButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ mergeButtonState: 3 })
        this.forceUpdate()
    }

    OnMouseUpMergeButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ mergeButtonState: 2 })
        this.forceUpdate()
    }

    // Delete button Handlers
    OnMouseClickDeleteButton(e: React.MouseEvent<HTMLDivElement>) {
        this.props.core.GetSelectionSetManager().onDeleteRequest(this.props.proRef)
    }

    OnMouseOutDeleteButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ delButtonState: 1 })
        this.forceUpdate()
    }

    OnMouseOverDeleteButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ delButtonState: 2 })
        this.forceUpdate()
    }

    OnMouseDownDeleteButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ delButtonState: 3 })
        this.forceUpdate()
    }

    OnMouseUpDeleteButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ delButtonState: 2 })
        this.forceUpdate()
    }

    OnItemEnter(e: React.MouseEvent<HTMLDivElement>){

    }
    
    OnClick(e: React.MouseEvent<HTMLDivElement>) {
        if (this.isSelected() == false) {
            if (this.props.proSummary != null) {
                this.props.core.SetSelectionID(this.props.proSummary.GetId())
            }
        }
        else {
            this.props.core.GetApp().ToggleExtInfo()
        }
    }
    
    // Rendering the project item as it should be displayed within the projectView 
    render() {
        const bgFile = "url(images/selectionLoadButtons.png)"
        var loadOffsetX = "-0px"
        var loadOffsetY = "-0px"
        var mergeOffsetX = "-33px"
        var mergeOffsetY = "-0px"
        var delOffsetX = "-128px"
        var delOffsetY = "-0px"
        var hoverstate = "out"
        const leftMargin = "12px"
        const left = "86px"
        const midLeftA = "86px"
        const midRightA = "67px"
        const rightMarginA = "0px"
        const itemHeightA = "30px"

        var elementsArt: Array<JSX.Element> = new Array<JSX.Element>()
        var elementsBP: Array<JSX.Element> = new Array<JSX.Element>()
        
        var loadOffsetX = "-0px"
        var loadOffsetY = "-0px"
        var mergeOffsetX = "-33px"
        var mergeOffsetY = "-0px"
        var delOffsetX = "-128px"
        var delOffsetY = "-0px"
        var hoverstate = "out"
        const midLeftSub = "67px"
        const midRightSub = "55px"
        const rightMarginSub = "0px"

        const itemsHeight = 30
        const itemHeightSub = 17
        const artsTitleHeight = 22
        const titleHeight = 42
        const buildEditAreaHeight = 167
        const buttonsLeftMargin = "33px"
        const buttonsCenterMargin = "10px"
        const buttonsAreaHeight = "38px"
        const itemFontSize = "16px"
        const itemYAdjustment = "1px"
        const separationMargin = 22

        const priceRadio = this.props.core.GetPriceRadio()
        const priceFlags = this.props.core.GetPriceFlags()

        var isSelected: boolean = (this.props.core.GetSelectionID() == this.props.proRef.GetId()) ? true : false
        var showingExtended: boolean = (isSelected && (this.props.core.GetApp().state.ExtInfoUp == true)) ? true : false
        var isHovered: boolean = (this.props.core.GetSelectionSetManager().GetHoveredProjectIndex() == this.props.index) ? true : false
        var keyIndex = 0

        if (isHovered == true) {
            hoverstate = "over"
        }

        var extInfoArrowOffset = 7
        var extInfoArrowShow = false // If or not the ext info dropdown arrow should be displayed

        // Hovering or selecting the item will cause it to render with some visual differences, and hoverstyle (below) holds the final set of characteristics to be rendered
        var hoverstyle: React.CSSProperties = { display: "flex", flexDirection: "row", width: '100%', height: "32px", borderTop: '1px solid white', borderBottom: '1px solid white' }
        var hoverstyle_hover: React.CSSProperties = { display: "flex", flexDirection: "row", width: '100%', height: "32px", backgroundColor: '#EAf3FF', borderTop: '1px solid #EAf3FF', borderBottom: '1px solid #EAf3FF' }
        var hoverstyle_selected: React.CSSProperties = { display: "flex", flexDirection: "row", width: '100%', height: "32px", backgroundColor: '#EAf3FF', borderTop: '1px solid #CAd3dF', borderBottom: '1px solid #CAd3dF' }

        // When the selected article is being hovered, the arrow to collapse/expand the extended info will light up a bit
        if (isHovered == true) {
            hoverstyle = hoverstyle_hover
            extInfoArrowOffset += 68
        }

        // If ext info is shown, the arrow will point upward as to show it can be hidden by clicking the article again
        if (this.props.core.GetApp().state.ExtInfoUp == true) {
            extInfoArrowOffset += 34
        }

        // Only the selected article can have an arrow to hide/show the extended info
        if (isSelected) {
            this.props.core.ConnectSelectedProjectItem(this)
            hoverstyle = hoverstyle_selected
            extInfoArrowShow = true
        }
        
        var extensionArea = <div></div>

        const bgPosition = "0px -" + extInfoArrowOffset.toString() + "px"
        var isVisible = (this.isSelected()) ? "visible" : "hidden"
        
        if ((isHovered == true) || (isSelected == true)) {
            mergeOffsetX = "-33px"
            mergeOffsetY = "-29px"

            if (this.state.mergeButtonState == 2) {
                mergeOffsetX = "-97px"
                mergeOffsetY = "-29px"
            }

            if (this.state.mergeButtonState == 3) {
                mergeOffsetX = "-97px"
                mergeOffsetY = "-58px"
            }

            loadOffsetX = "-0px"
            loadOffsetY = "-29px"

            if (this.state.loadButtonState == 2) {
                loadOffsetX = "-64px"
                loadOffsetY = "-29px"
            }

            if (this.state.loadButtonState == 3) {
                loadOffsetX = "-64px"
                loadOffsetY = "-58px"
            }

            delOffsetX = "-128px"
            delOffsetY = "-29px"

            if (this.state.delButtonState == 2) {
                delOffsetX = "-160px"
                delOffsetY = "-29px"
            }

            if (this.state.delButtonState == 3) {
                delOffsetX = "-160px"
                delOffsetY = "-58px"
            }

            // Putting together the background image position
            var loadBgPosition = loadOffsetX + " " + loadOffsetY
            var mergeBgPosition = mergeOffsetX + " " + mergeOffsetY
            var delBgPosition = delOffsetX + " " + delOffsetY
            
            var SubBPAmount = 0
            var ArticleAmount = 0

            if (this.props.proSummary != null) {
                if (this.props.proSummary.GetIncludedBuildParts() != null) {
                    SubBPAmount = (showingExtended == true) ? (this.props.proSummary.GetIncludedBuildParts().length) : 0

                    // Adding the title area:
                    if (SubBPAmount > 0) {
                        const keyStr0 = (keyIndex++).toString()
                        {/* separation margin */ }
                        elementsBP.push(<div key={keyStr0} style={{ width: "100%", height: (separationMargin.toString() + "px") }}>

                        </div>)

                        const keyStr1 = (keyIndex++).toString()

                        {/* title area */ }
                        elementsBP.push(<div key={keyStr1} style={{ width: "100%", height: (titleHeight.toString() + "px") }}>
                            <div style={{ position: "relative", left: buttonsLeftMargin, top: "10px", fontSize: "18px", color: "gray" }}>
                                Inkluderte Byggdeler:
                            </div>
                        </div>)
                        
                        const keyStr2 = (keyIndex++).toString()

                        {/* build parts title area */ }
                        elementsBP.push(<div key={keyStr2} style={{ width: "100%", height: (artsTitleHeight.toString() + "px"), display: "flex", flexDirection: "row", fontSize: "18px" }}>
                            <div style={{ width: "33px" }} >
                            </div>

                            <div style={{ width: "35px", color: "gray", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                                Antall
                            </div>

                            <div style={{ width: "45px", color: "gray", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                            </div>

                            <div style={{ width: "350px", color: "gray", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                                Byggdel
                            </div>

                            <div style={{ width: "120px", color: "gray", textAlign: "right", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                                Pris
                            </div>

                            <div style={{ width: "140px", color: "gray", textAlign: "right", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                                Summa
                            </div>
                        </div>)
                    }

                    var parts = this.props.proSummary.GetIncludedBuildParts()
                    for (var i = 0; (i < parts.length) && (showingExtended == true); i++) {
                        const keyStr = (keyIndex++).toString()
                        if (parts[i].amount != 0) {
                            elementsBP.push(<div key={keyStr} style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                                <div style={{ width: "33px" }}></div>
                                <div style={{ color: "grey", width: "35px" }}>{parts[i].amount}</div>
                                <div style={{ color: "grey", width: "45px" }}></div>
                                <div style={{ color: "grey", width: "350px" }}>{parts[i].ref.GetTitle()}</div>
                                <div style={{ color: "grey", width: "120px", textAlign: "right" }}>{parts[i].ref.GetPriceString(priceRadio, priceFlags)}</div>
                                <div style={{ color: "grey", width: "140px", textAlign: "right" }}>{this.GetAsTwoDecimalString(parts[i].ref.GetPrice(priceRadio, priceFlags) * parts[i].amount)}</div>
                            </div>)
                        }
                    }
                }

                var arts = this.props.proSummary.GetArticles()

                for (var i = 0; (i < arts.length) && (showingExtended == true); i++) {
                    const keyStr = (keyIndex++).toString()
                    if (arts[i].GetAmount() > 0) {
                        ArticleAmount++
                        elementsArt.push(<div key={keyStr} style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                            <div style={{ width: "33px" }}></div>
                            <div style={{ color: "grey", width: "35px" }}>{arts[i].GetAmount()}</div>
                            <div style={{ color: "grey", width: "45px" }}>{arts[i].GetUnit()}</div>
                            <div style={{ color: "grey", width: "350px" }}>{arts[i].GetDescription()}</div>
                            <div style={{ color: "grey", width: "120px", textAlign: "right" }}>{arts[i].GetUnitPriceString(priceRadio, priceFlags, false, null)}</div>
                            <div style={{ color: "grey", width: "140px", textAlign: "right" }}>{arts[i].GetSumString(priceRadio, priceFlags)}</div>
                        </div>)
                    }
                }
            }

            var extAreaHeight = 0

            if (showingExtended == true) {
                // Article content section
                extAreaHeight += artsTitleHeight
                extAreaHeight += titleHeight
                extAreaHeight += (ArticleAmount * itemHeightSub)

                // Included buildparts section
                extAreaHeight += (SubBPAmount * itemHeightSub)
                extAreaHeight += (SubBPAmount != 0) ? titleHeight : 0 // Adding space for the title above included buildparts
                extAreaHeight += (SubBPAmount != 0) ? artsTitleHeight : 0 // Adding space for the row of titles above included buildparts
                extAreaHeight += (SubBPAmount != 0) ? separationMargin : 0 // Adding space for separation margin
                extAreaHeight += 10 // Bottom margin
            }

            var totHeight = (itemsHeight + extAreaHeight).toString() + "px"
            var topHeight = itemsHeight.toString() + "px"

            var favStr = ""
            
            if (showingExtended == true) {
                extensionArea = <div style={{ backgroundColor: '#EAf3FF', width: "100%", height: (extAreaHeight.toString() + "px"), borderBottom: '1px solid #CAd3dF' }}
                    onMouseEnter={e => this.onMouseOverWhole(e)}>
                    {/* title area */}
                    <div style={{ width: "100%", height: (titleHeight.toString() + "px") }}>
                        <div style={{ position: "relative", left: buttonsLeftMargin, top: "10px", fontSize: "18px", color: "gray" }}>
                            Innhold:
                        </div>
                    </div>

                    {/* articles title area */}
                    <div style={{ width: "100%", height: (artsTitleHeight.toString() + "px"), display: "flex", flexDirection: "row", fontSize: "18px" }}>
                        <div style={{ width: "33px" }} >
                        </div>

                        <div style={{ width: "35px", color: "gray", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                            Ant
                        </div>

                        <div style={{ width: "45px", color: "gray", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                            Enh
                        </div>

                        <div style={{ width: "350px", color: "gray", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                            Varetext
                        </div>

                        <div style={{ width: "120px", color: "gray", textAlign: "right", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                            Pris
                        </div>

                        <div style={{ width: "140px", color: "gray", textAlign: "right", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                            Sum
                        </div>
                    </div>

                    {elementsArt}
                    {elementsBP}

                    <div style={{ height: "15px" }}>
                    </div>

                </div>
            }
            else {
                totHeight = "0px"
            }
            
            return <div >
                <div
                    onMouseOut={e => this.onMouseOut(e)}
                    onMouseEnter={e => this.onMouseOver(e)}
                    onClick={e => this.OnClick(e)}
                    style={hoverstyle}>

                    {/* Ext Info arrowdown area */}
                    <div style={{ width: "25px", height: "20px", backgroundImage: "url(images/UtvidetInfoLocalArrow.png)", backgroundPosition: bgPosition, visibility: isVisible, position: "relative", top: "4px", left: "5px" }} ></div>

                    <div style={{ width: leftMargin }}>
                    </div>

                    <div style={{ width: left, height: itemHeightA}}>
                        <div style={{ width: "32px", height: "29px", backgroundImage: bgFile, backgroundPosition: loadBgPosition }}
                            onClick={this.OnMouseClickLoadButton.bind(this)}
                            onMouseOut={e => this.OnMouseOutLoadButton(e)}
                            onMouseEnter={e => this.OnMouseOverLoadButton(e)}
                            onMouseDown={e => this.OnMouseDownLoadButton(e)}
                            onMouseUp={e => this.OnMouseUpLoadButton(e)}>
                        </div>
                    </div>

                    <div style={{ width: midLeftA, height: itemHeightA}}>
                        <div className="tooltip" style={{ width: "32px", height: "29px", backgroundImage: bgFile, backgroundPosition: mergeBgPosition }}
                            onClick={this.OnMouseClickMergeButton.bind(this)}
                            onMouseOut={e => this.OnMouseOutMergeButton(e)}
                            onMouseEnter={e => this.OnMouseOverMergeButton(e)}
                            onMouseDown={e => this.OnMouseDownMergeButton(e)}
                            onMouseUp={e => this.OnMouseUpMergeButton(e)}>
                        </div>
                    </div>

                    <div style={{ width: midRightA, height: itemHeightA }}>
                        <div className="tooltip" style={{ width: "32px", height: "29px", backgroundImage: bgFile, backgroundPosition: delBgPosition}}
                            onClick={this.OnMouseClickDeleteButton.bind(this)}
                            onMouseOut={e => this.OnMouseOutDeleteButton(e)}
                            onMouseEnter={e => this.OnMouseOverDeleteButton(e)}
                            onMouseDown={e => this.OnMouseDownDeleteButton(e)}
                            onMouseUp={e => this.OnMouseUpDeleteButton(e)}>
                        </div>
                    </div>
                    
                    <div style={{ width: rightMarginA, height: "1px" }}>
                    </div>

                    <div style={{ width: "320px", fontSize: "24px", color: "grey" }}>{this.props.proRef.GetName()}
                    </div>

                    <div style={{ width: rightMarginA, height: "1px" }}>
                    </div>

                    <div>{this.props.proRef.GetSavedTime(this.props.core.GetLocalTimeDifference())}
                    </div>
                </div>
                {extensionArea}
            </div>
        }
        else {
            // Putting together the background image position
            var loadBgPosition = loadOffsetX + " " + loadOffsetY
            var mergeBgPosition = mergeOffsetX + " " + mergeOffsetY
            var delBgPosition = delOffsetX + " " + delOffsetY

            return <div
                onMouseOut={e => this.onMouseOut(e)}
                onMouseEnter={e => this.onMouseOver(e)}
                style={hoverstyle}>
                
                {/* Ext Info arrowdown area */}
                <div style={{ width: "25px", height: "20px", backgroundImage: "url(images/UtvidetInfoLocalArrow.png)", backgroundPosition: bgPosition, visibility: isVisible, position: "relative", top: "4px", left: "5px" }} ></div>

                <div style={{ width: leftMargin }}>
                </div>

                <div style={{ width: left, height: itemHeightA, position: "relative" }}>
                    <div style={{ width: "32px", height: "29px", backgroundImage: bgFile, backgroundPosition: loadBgPosition }}
                        onClick={this.OnMouseClickLoadButton.bind(this)}
                        onMouseOut={e => this.OnMouseOutLoadButton(e)}
                        onMouseEnter={e => this.OnMouseOverLoadButton(e)}
                        onMouseDown={e => this.OnMouseDownLoadButton(e)}
                        onMouseUp={e => this.OnMouseUpLoadButton(e)}>
                    </div>
                </div>

                <div style={{ width: midLeftA, height: itemHeightA}}>
                    <div className="tooltip" style={{ width: "32px", height: "29px", backgroundImage: bgFile, backgroundPosition: mergeBgPosition }}
                        onClick={this.OnMouseClickMergeButton.bind(this)}
                        onMouseOut={e => this.OnMouseOutMergeButton(e)}
                        onMouseEnter={e => this.OnMouseOverMergeButton(e)}
                        onMouseDown={e => this.OnMouseDownMergeButton(e)}
                        onMouseUp={e => this.OnMouseUpMergeButton(e)}>
                    </div>
                </div>

                <div style={{ width: midRightA, height: itemHeightA }}>
                    <div className="tooltip" style={{ width: "32px", height: "29px", backgroundImage: bgFile, backgroundPosition: delBgPosition }}
                        onClick={this.OnMouseClickDeleteButton.bind(this)}
                        onMouseOut={e => this.OnMouseOutDeleteButton(e)}
                        onMouseEnter={e => this.OnMouseOverDeleteButton(e)}
                        onMouseDown={e => this.OnMouseDownDeleteButton(e)}
                        onMouseUp={e => this.OnMouseUpDeleteButton(e)}>
                    </div>
                </div>

                <div style={{ width: rightMarginA, height: "1px" }}>
                </div>

                <div style={{ width: "320px", fontSize: "24px", color: "grey" }}>{this.props.proRef.GetName()}
                </div>

                <div style={{ width: rightMarginA, height: "1px" }}>
                </div>

                <div>{this.props.proRef.GetSavedTime(this.props.core.GetLocalTimeDifference())}
                </div>
            </div>
        }
    }

    GetAsTwoDecimalString(value: number) {
        var result = value.toString()
        var decimalsShown = 0
        var passedComma = false

        // Counting the decimals of the total sum string
        for (var i = 0; i < result.length; i++) {
            if (passedComma == true) {
                decimalsShown++
            }

            // Ensuring there is no more than two decimals shown
            if (decimalsShown > 2) {
                result = result.slice(0, i)
                break
            }

            if (result[i] == '.') {
                passedComma = true
            }
        }

        // Ensuring there is allways two decimals shown on the total sum 
        if (decimalsShown == 0) {
            result += ".00"
        }

        if (decimalsShown == 1) {
            result += "0"
        }

        return result
    }
}




// WEBPACK FOOTER //
// ./client/view/ProjectItem.tsx